import React from 'react';
import { useDispatch } from 'react-redux';
import ToolbarTool from '../../ToolbarTool';
import Icon from '../../../../../components/icons/light/IconLightSizeLarge';
import { updateMultipleElements } from '../../../../../element/actions/elementActions';
import { isLink } from '../../../../../../common/elements/utils/elementTypeUtils';
import { useTranslator } from '../../../../../components/i18n/useTranslator';
import { MediaOnlyDisplay } from '../../../../../element/resizing/resizeTypes';
import { getIsMediaOnlyDisplayPreferred } from '../../../../../element/media/mediaElementDisplayUtils';
import { ImMNElement } from '../../../../../../common/elements/elementModelTypes';

type Props = {
    selectedElements: Immutable.List<ImMNElement>;
    selectedElementIds: Immutable.List<string>;
};

const DisplayInfoTool = (props: Props) => {
    const { selectedElements, selectedElementIds } = props;

    const dispatch = useDispatch();
    const translate = useTranslator('toolbar');

    const firstElement = selectedElements.first();
    const showMediaOnly = getIsMediaOnlyDisplayPreferred(firstElement);

    const onClick = () => {
        const newMediaOnlyDisplay = showMediaOnly ? MediaOnlyDisplay.SHOW_ALL : MediaOnlyDisplay.PREFERENCE;

        dispatch(
            updateMultipleElements({
                updates: selectedElementIds.toJS().map((id: string) => ({
                    id,
                    changes: {
                        mediaOnlyDisplay: newMediaOnlyDisplay,
                    },
                })),
            }),
        );
    };

    const isLinkElement = isLink(firstElement);
    const toolName = isLinkElement
        ? translate(`tools.selected.linkInfo`, 'Link info')
        : translate('tools.selected.fileInfo', 'File info');
    const iconName = isLinkElement ? 'toolbar-hyperlink' : 'toolbar-upload';

    return (
        <div className="DisplayInfoTool">
            <ToolbarTool {...props} name={toolName} isActive={!showMediaOnly} onClick={onClick}>
                <Icon name={iconName} />
            </ToolbarTool>
        </div>
    );
};

export default DisplayInfoTool;
